<template>
  <div>
      <div v-for="(techAreas, areaIdx) in techSkills" :key="areaIdx">
        <h4>{{ techAreas.name }}</h4>
        <div class="techSkills" v-for="(techSkills, skillIdx) in techAreas.list" :key="skillIdx">
          <cssCircle
            v-bind:percent="techSkills.value"
            v-bind:icon="techSkills.icon"
            v-bind:name="techSkills.name"
            v-bind:color1="techSkills.color1"
          />

        </div>
      </div>
  </div>
</template>


<script>
import cssCircle from '../general/v-circle/css-circle'
export default {
  name: 'Techskills',
  components: {
    cssCircle
  },
  methods: {
  },
  data: function() {
       return  {
         techSkills: [
{
  name: 'Cloud Platforms',
  color: 'blue',
  list: [
    {
      name: 'AWS',
      color1: '#F29C1F',
      color2: '#F29C1F',
      icon: 'icon-aws',
      value: 85
    },
    {
      name: 'Azure',
      color1: '#37B7E9',
      color2: '#37B7E9',
      icon: 'devicon-azure-plain',
      value: 80
    },
    {
      name: 'Google Cloud',
      color1: '#4285F4',
      color2: '#4285F4',
      icon: 'devicon-googlecloud-plain',
      value: 50
    },
    {
      name: 'OpenStack',
      color1: '#E61D47',
      color2: '#E61D47',
      icon: 'devicon-openstack-original colored',
      value: 70
    },
    {
      name: 'OpenShift',
      color1: '#D52629',
      color2: '#D52629',
      icon: 'icon-openshift',
      value: 85
    }
  ]
},
{
  name: 'AI / GenAI & Data',
  color: 'blue',
  list: [
    {
      name: 'GenAI / LLMs',
      color1: '#7C3AED',
      color2: '#7C3AED',
      icon: 'fas fa-robot',
      value: 85
    },
    {
      name: 'RAG',
      color1: '#0F766E',
      color2: '#0F766E',
      icon: 'fas fa-search',
      value: 85
    },
    {
      name: 'Vector DBs',
      color1: '#2563EB',
      color2: '#2563EB',
      icon: 'fas fa-project-diagram',
      value: 75
    },
    {
      name: 'MLOps',
      color1: '#B7791F',
      color2: '#B7791F',
      icon: 'fas fa-sync-alt',
      value: 75
    },
    {
      name: 'PySpark',
      color1: '#E25A1C',
      color2: '#E25A1C',
      icon: 'fas fa-bolt',
      value: 70
    },
    {
      name: 'Databricks',
      color1: '#FF3621',
      color2: '#FF3621',
      icon: 'fas fa-layer-group',
      value: 65
    }
  ]
},
{
  name: 'Cloud & Observabilidad',
  color: 'blue',
  list: [
    {
      name: 'Istio',
      color1: '#466BB0',
      color2: '#ffffff',
      icon: 'fas fa-network-wired',
      value: 60
    },
    {
      name: 'Prometheus',
      color1: '#E6522C',
      color2: '#000000',
      icon: 'devicon-prometheus-original',
      value: 85
    },
    {
      name: 'Loki',
      color1: '#6A5ACD',
      color2: '#000',
      icon: 'fas fa-stream',
      value: 80
    },
    {
      name: 'Tempo',
      color1: '#FFA500',
      color2: '#000000',
      icon: 'fas fa-stopwatch',
      value: 60
    },
    {
      name: 'Airflow',
      color1: '#017CEE',
      color2: '#019A90',
      icon: 'fas fa-wind',
      value: 75
    },
    {
      name: 'Superset',
      color1: '#333',
      color2: '#FC4F3F',
      icon: 'fas fa-chart-line',
      value: 80
    },
    {
      name: 'Keycloak',
      color1: '#35495e',
      color2: '#5C6BC0',
      icon: 'fas fa-user-shield',
      value: 75
    }
  ]
},

           {
             name: 'frontend',
             color: 'red',
             list: [
               {
                 name: 'html5',
                 color1: '#f06529',
                 color2: '#ebebeb',
                 icon: 'fab fa-html5',
                 value: 95
               },
               {
                 name: 'css3',
                 color1: '#0070BA',
                 color2: '#28A9E0',
                 icon: 'fab fa-css3-alt',
                 value: 80
               },
               {
                 name: 'js',
                 color1: '#f0db4f',
                 color2: '#323330',
                 icon: 'fab fa-js',
                 value: 90
               },
               {
                 name: 'vue',
                 color1: '#42b883',
                 color2: '#35495e',
                 icon: 'fab fa-vuejs',
                 value: 80
               },
               {
                 name: 'vue',
                 color1: '#42b883',
                 color2: '#35495e',
                 icon: 'devicon-nuxtjs-plain colored',
                 value: 80
               },
               {
                 name: 'react',
                 color1: '#71D7FA',
                 color2: '#151515',
                 icon: 'fab fa-react',
                 value: 70
               },
               {
                 name: 'jquery',
                 color1: '#0868AC',
                 color2: '#61dbfb',
                 icon: 'icon-jquery',
                 value: 80
               },
               {
                 name: 'bootstrap',
                 color1: '#080135',
                 color2: '#602c50',
                 icon: 'icon-bootstrap',
                 value: 90
               },
               {
                 name: 'angular',
                 color1: '#b52e31',
                 color2: '#cccccc',
                 icon: 'fab fa-angular',
                 value: 70
               },
               {
                 name: 'D3',
                 color1: '#DE754C',
                 color2: '#F99E40',
                 icon: 'icon-d3',
                 value: 70
               },
               {
                 name: 'sass',
                 color1: '#CC6498',
                 color2: '#1D2130',
                 icon: 'icon-sass',
                 value: 85
               },
               {
                 name: 'less',
                 color1: '#5A367C',
                 color2: '#fff',
                 icon: 'devicon-less-plain-wordmark',
                 value: 85
               },
               {
                 name: 'webpack',
                 color1: '#96D1F9',
                 color2: '#3972BD',
                 icon: 'devicon-webpack-plain',
                 value: 90
               },
               {
                 name: 'react',
                 color1: '#01D1F7',
                 color2: '#01D1F7',
                 icon: 'devicon-react-original',
                 value: 90
               }
             ]
           },
           {
             name: 'backend',
             color: 'blue',
             list: [
               {
                 name: 'nodejs',
                 color1: '#8CC84B',
                 color2: '#46483E',
                 icon: 'devicon-nodejs-plain',
                 value: 95
               },
               {
                 name: 'express',
                 color1: '#353535',
                 color2: '#c1c1c1',
                 icon: 'devicon-express-original',
                 value: 95
               },
               {
                 name: 'fastapi',
                 color1: '#079487',
                 color2: '#fff',
                 icon: 'devicon-fastapi-plain',
                 value: 90
               },
               {
                 name: 'flask',
                 color1: '#080808',
                 color2: '#080808',
                 icon: 'devicon-flask-original',
                 value: 90
               },
               {
                 name: 'php',
                 color1: '#4f5b93',
                 color2: '#8892be',
                 icon: 'icon-php',
                 value: 80
               },
               {
                 name: 'django',
                 color1: '#084025',
                 color2: '#fff',
                 icon: 'devicon-django-plain',
                 value: 80
               },
               {
                 name: 'apache',
                 color1: '#D42129',
                 color2: '#83297B',
                 icon: 'icon-apache',
                 value: 75
               },
               {
                 name: 'nginx',
                 color1: '#0D974D',
                 color2: '#353535',
                 icon: 'devicon-nginx-original',
                 value: 80
               },
               {
                 name: 'mocha',
                 color1: '#8D6748',
                 color2: '#ddd',
                 icon: 'devicon-mocha-plain',
                 value: 85
               },
               {
                 name: 'gulp',
                 color1: '#F4AD1E',
                 color2: '#E18B23',
                 icon: 'icon-grunt',
                 value: 70
               },
               {
                 name: 'grunt',
                 color1: '#E5524E',
                 color2: '#fff',
                 icon: 'icon-gulp',
                 value: 80
               }
               
             ]
           },
           {
             name: 'DevOps',
             color: 'red',
             list: [
               {
                 name: 'linux',
                 color1: '#010102',
                 color2: '#fff',
                 icon: 'devicon-linux-plain',
                 value: 70
               },
               {
                 name: 'docker',
                 color1: '#4294EA',
                 color2: '#fff',
                 icon: 'devicon-docker-plain',
                 value: 90
               },
               {
                 name: 'kubernetes',
                 color1: '#2F69DE',
                 color2: '#2F69DE',
                 icon: 'devicon-kubernetes-plain colored',
                 value: 80
               },
               {
                 name: 'helm',
                 color1: '#0F1585',
                 color2: '#0F1585',
                 icon: 'devicon-helm-original',
                 value: 80
               },
               {
                 name: 'terraform',
                 color1: '#7C3BEB',
                 color2: '#7C3BEB',
                 icon: 'devicon-terraform-plain',
                 value: 85
               },         
               {
                 name: 'Ansible',
                 color1: '#000',
                 color2: '#00',
                 icon: 'devicon-ansible-plain',
                 value: 80
               },                 
               {
                 name: 'jenkis',
                 color1: '#335061',
                 color2: '#CD4231',
                 icon: 'fab fa-jenkins',
                 value: 70
               },
               {
                 name: 'ubuntu',
                 color1: '#D75110',
                 color2: '#fff',
                 icon: 'icon-ubuntu',
                 value: 80
               },
               {
                 name: 'Digital Ocean',
                 color1: '#007CF7',
                 color2: '#007CF7',
                 icon: 'devicon-digitalocean-original',
                 value: 80
               },
               {
                 name: 'debian',
                 color1: '#D21053',
                 color2: '#fff',
                 icon: 'icon-debian',
                 value: 70
               },
               {
                 name: 'hedhat',
                 color1: '#E91D0B',
                 color2: '#000',
                 icon: 'icon-redhat',
                 value: 60
               },
               {
                 name: 'git',
                 color1: '#D74934',
                 color2: '#D74934',
                 icon: 'devicon-git-plain',
                 value: 90
               },
               {
                 name: 'github',
                 color1: '#000',
                 color2: '#fff',
                 icon: 'devicon-github-original',
                 value: 70
               },
               {
                 name: 'gitlab',
                 color1: '#DB4127',
                 color2: '#F49E25',
                 icon: ' devicon-gitlab-plain colored',
                 value: 90
               },
               {
                 name: 'gitbucket',
                 color1: '#1F4D7D',
                 color2: '#1F4D7D',
                 icon: 'devicon-bitbucket-original',
                 value: 90
               },
               {
                 name: 'opentelemetry',
                 color1: '#495CA6',
                 color2: '#495CA6',
                 icon: 'devicon-opentelemetry-plain',
                 value: 70
               },
               {
                 name: 'open api',
                 color1: '#689F38',
                 color2: '#689F38',
                 icon: 'devicon-openapi-plain',
                 value: 100
               },
               {
                 name: 'grafana',
                 color1: '#E95727',
                 color2: '#E95727',
                 icon: 'devicon-grafana-plain',
                 value: 90
               },
               {
                 name: 'portainer',
                 color1: '#36D3F7',
                 color2: '#36D3F7',
                 icon: 'devicon-portainer-original',
                 value: 90
               },
               {
                 name: 'vagrant',
                 color1: '#1156C6',
                 color2: '#1156C6',
                 icon: 'devicon-vagrant-plain',
                 value: 60
               }
             ]
           },
           {
             name: 'Databases & Infra Stuff s',
             color: 'red',
             list: [
               {
                 name: 'SQL',
                 color1: '#98201C',
                 color2: '#000',
                 icon: 'icon-mssql',
                 value: 80
               },
               {
                 name: 'mysql',
                 color1: '#155C89',
                 color2: '#145D88',
                 icon: 'icon-mysql',
                 value: 90
               },
               {
                 name: 'postgres',
                 color1: '#3E618B',
                 color2: '#fff',
                 icon: 'icon-postgres',
                 value: 80
               },
               {
                 name: 'mongodb',
                 color1: '#65B346',
                 color2: '#C1BEBF',
                 icon: 'icon-mongodb',
                 value: 85
               },
               {
                 name: 'redis',
                 color1: '#8D211C',
                 color2: '#C03624',
                 icon: 'icon-redis',
                 value: 75
               },
               {
                 name: 'cassandra',
                 color1: '#2982AE',
                 color2: '#D4EDFB',
                 icon: 'icon-cassandra',
                 value: 50
               },
               {
                 name: 'neo4j',
                 color1: '#155C89',
                 color2: '#145D88',
                 icon: 'devicon-neo4j-plain',
                 value: 70
               },
               {
                 name: 'Elastic Search',
                 color1: '#221E1F',
                 color2: '#221E1F',
                 icon: 'devicon-elasticsearch-plain',
                 value: 70
               },
               {
                 name: 'Oracle',
                 color1: '#DE1F23',
                 color2: '#DE1F23',
                 icon: 'devicon-oracle-original',
                 value: 70
               },
               {
                 name: 'Kafka',
                 color1: '#201E1F',
                 color2: '#201E1F',
                 icon: 'devicon-apachekafka-original',
                 value: 70
               },
               {
                 name: 'Rabbit',
                 color1: '#F76401',
                 color2: '#F76401',
                 icon: 'devicon-rabbitmq-original',
                 value: 90
               },
               {
                 name: 'Vault',
                 color1: '#000',
                 color2: '#000',
                 icon: 'devicon-vault-original',
                 value: 90
               }
               
             ]
           },
           {
             name: 'Other Programming Languages, data, Machine learning & IA',
             color: 'red',
             list: [
               {
                 name: 'C++',
                 color1: '#2F65A1',
                 color2: '#fff',
                 icon: 'icon-cplusplus',
                 value: 80
               },
               {
                 name: 'Go',
                 color1: '#73D4E3',
                 color2: '#fff',
                 icon: 'icon-go',
                 value: 70
               },
               {
                 name: 'Typescript',
                 color1: '#3074C0',
                 color2: '#3074C0',
                 icon: 'devicon-typescript-plain',
                 value: 80
               },
               {
                 name: 'Python',
                 color1: '#F8D94F',
                 color2: '#446B9C',
                 icon: 'icon-python',
                 value: 90
               },
               {
                 name: 'Jupyter',
                 color1: '#EB7324',
                 color2: '#EB7324',
                 icon: 'devicon-jupyter-plain-wordmark',
                 value: 90
               },
              {
                 name: 'Keras',
                 color1: '#CA0000',
                 color2: '#CA0000',
                 icon: 'devicon-keras-plain',
                 value: 60
               },
              {
                 name: 'Matploblib',
                 color1: '#F37E2F',
                 color2: '#F37E2F',
                 icon: 'devicon-matplotlib-plain',
                 value: 60
               },
               {
                 name: 'numpy',
                 color1: '#4B73C9',
                 color2: '#4B73C9',
                 icon: 'devicon-numpy-plain',
                 value: 80
               },
               {
                 name: 'Pandas',
                 color1: '#0F054F',
                 color2: '#0F054F',
                 icon: 'devicon-pandas-plain',
                 value: 85
               },
              {
                 name: 'networkx',
                 color1: '#2A7BB2',
                 color2: '#2A7BB2',
                 icon: 'devicon-networkx-plain',
                 value: 60
               },
               {
                 name: 'Poetry',
                 color1: '#0189D9',
                 color2: '#0189D9',
                 icon: 'devicon-poetry-plain',
                 value: 100
               },
               {
                 name: 'Pytest',
                 color1: '#0189D9',
                 color2: '#0189D9',
                 icon: 'devicon-pytest-plain',
                 value: 90
               },
               {
                 name: 'Pytoch',
                 color1: '#0189D9',
                 color2: '#0189D9',
                 icon: 'devicon-pytorch-original',
                 value: 90
               }



               
             ]
           },
           {
             name: 'CMS, ERP, CRM',
             color: 'red',
             list: [
               {
                 name: 'Wordpress',
                 color1: '#376F9A',
                 color2: '#2C333D',
                 icon: 'icon-wordpress',
                 value: 90
               },
               {
                 name: 'Odoo',
                 color1: '#A04687',
                 color2: '#8E8E8E',
                 icon: 'far fa-circle',
                 value: 80
               }
             ]
           },
           {
             name: 'other tech Skills',
             color: 'red',
             list: [
               {
                 name: 'Electronics',
                 color1: '#333',
                 color2: '#000',
                 icon: 'fas fa-microchip',
                 value: 80
               },
               {
                 name: 'Raspberry',
                 color1: '#BF184B',
                 color2: '#67C14E',
                 icon: 'icon-raspberrypi',
                 value: 80
               },
               {
                 name: 'Arduino',
                 color1: '#169096',
                 color2: '#169096',
                 icon: 'devicon-arduino-plain',
                 value: 80
               },
               {
                 name: 'VS Code',
                 color1: '#027EC9',
                 color2: '#027EC9',
                 icon: 'devicon-vscode-plain',
                 value: 97
               },

               
               {
                 name: '3Dprinter',
                 color1: '#555',
                 color2: '#000',
                 icon: 'icon-3dprint',
                 value: 80
               },
               {
                 name: 'Jira',
                 color1: '#257DF6',
                 color2: '#257DF6',
                 icon: 'devicon-jira-plain',
                 value: 95
               },
               {
                 name: 'Trello',
                 color1: '#2973BC',
                 color2: '#fff',
                 icon: 'devicon-trello-plain',
                 value: 95
               },
               {
                 name: 'Postman',
                 color1: '#F76835',
                 color2: '#F76835',
                 icon: 'devicon-postman-plain',
                 value: 95
               }
               
             ]
           }

         ]
       }
  },
  data2: {
    circles: {
      backend: {
        color: 'red',
        list:[]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.techSkills{
  display: inline-block;
  margin-right: 20px;
}


</style>
